import { OnboardingImage3, useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type FC } from 'react';

import * as S from './components.styled';
import { Shell } from './Shell';

export const FourthPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const { $t } = useIntl();

	return (
		<Shell
			cta={
				<S.CTAWrapper>
					<Button
						color="brand"
						testID="onboarding-register-button"
						text={$t('onboarding.buttons.register')}
						onClick={next}
					/>
				</S.CTAWrapper>
			}
			goBack={goBack}
		>
			<S.ImageWrapper>
				<S.Image
					alt="onboarding-fourth-slide-image"
					data-testid="onboarding-third-slide-image"
					src={OnboardingImage3}
				/>
			</S.ImageWrapper>
			<S.HeadlineText>
				{$t<JSX.Element>('onboarding.screen3Headline', {
					blue: chunks => <S.Blue>{chunks}</S.Blue>
				})}
			</S.HeadlineText>
			<S.Dropline>{$t('onboarding.screen3Dropheadline')}</S.Dropline>
		</Shell>
	);
};
